import { subtitles } from './subtitles';

export const v1 = {
  subtitles,
};
